import {
  BOOK_TENANT_REQUEST,
  BOOK_TENANT_SUCCESS,
  BOOK_TENANT_FAILURE,
  RESE_BOOK_TENANT_SUCCESS
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  bookings: {},
  error: null,
  bookingSuccess: false,
};


const bookingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOK_TENANT_REQUEST:
      return {
        ...state,
        loading: true,
        bookingSuccess: false,
      };
    case BOOK_TENANT_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingSuccess: true,
        bookings: {
          ...state.bookings,
          ...action.payload, // Update state with new booking data if needed
        },
      };
    case BOOK_TENANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        bookingSuccess: false,
      };
    case RESE_BOOK_TENANT_SUCCESS:
      return {
        ...state,
        error: null,
        bookingSuccess: false,
      };
    default:
      return state;
  }
};

export default bookingsReducer;


